import clsx from 'clsx';

import type { Adaptive } from '../types/Adaptive';
import type { Width } from '../types/Width';

export function composeWidthClasses(width: Adaptive<Width>): string {
    if (typeof width === 'object') {
        return clsx(
            width.base && `w-${width.base}`,
            width.sm && `sm:w-${width.sm}`,
            width.md && `md:w-${width.md}`,
            width.lg && `lg:w-${width.lg}`,
            width.xl && `xl:w-${width.xl}`,
            width['2xl'] && `2xl:w-${width['2xl']}`
        );
    }

    return `w-${width}`;
}
